if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      /*
       * 页面组件。
       */
      this.filtersComponent =
        document.querySelector(
          'facet-filters'
        );

      this.filtersColumn =
        document.querySelector(
          '.main-products-grid__filters'
        );

      this.layoutSwitcher =
        this.querySelector(
          '.products-toolbar__layout'
        );

      this.compareToggle =
        document.getElementById(
          'compare-switch'
        );

      this.sortBy =
        this.querySelector(
          '.products-toolbar__sort'
        );

      this.productsGrid =
        document.querySelector(
          '.main-products-grid'
        );

      /*
       * 完整 Filter 按钮。
       */
      this.filterToggle =
        this.querySelector(
          '.js-toggle-filters'
        );

      /*
       * Category、Color、Size、Activity。
       */
      this.quickFilterButtons = [
        ...this.querySelectorAll(
          '.js-open-filter-group'
        )
      ];

      /*
       * 绑定完整 Filter 按钮。
       *
       * 不再使用 filtersColumn 作为判断条件，
       * 因为现在 PC 和移动端都使用抽屉。
       */
      if (
        this.filtersComponent &&
        this.filterToggle
      ) {
        this.filterToggle.addEventListener(
          'click',
          this.toggleFilters.bind(this)
        );
      }

      /*
       * 绑定快捷筛选按钮。
       */
      if (
        this.filtersComponent &&
        this.quickFilterButtons.length
      ) {
        this.quickFilterButtons.forEach(
          (button) => {
            button.addEventListener(
              'click',
              this.openFilterGroup.bind(
                this
              )
            );
          }
        );
      }

      /*
       * 抽屉关闭时恢复按钮状态。
       */
      if (this.filtersComponent) {
        this.filtersComponent.addEventListener(
          'click',
          (event) => {
            if (
              event.target.closest(
                '.js-close-drawer'
              )
            ) {
              this.resetFilterButtonStates();
            }
          }
        );
      }

      /*
       * Grid/List 布局切换。
       */
      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener(
          'change',
          this.handleLayoutChange.bind(
            this
          )
        );

        /*
         * 读取用户之前保存的布局。
         */
        const layout =
          theme.storageUtil.get(
            'products-layout'
          );

        if (
          layout &&
          layout === 'list'
        ) {
          const toggle =
            document.getElementById(
              `${layout}-layout-opt`
            );

          if (toggle) {
            toggle.click();
          }

          this.handleLayoutChange(
            null,
            layout
          );
        }
      }

      /*
       * Compare 开关。
       */
      if (this.compareToggle) {
        this.compareToggle.addEventListener(
          'change',
          this.toggleCompare.bind(this)
        );

        const isChecked =
          theme.storageUtil.get(
            'compare-toggle',
            true
          );

        if (isChecked !== null) {
          this.toggleCompare(
            null,
            isChecked,
            true
          );
        } else {
          this.toggleCompare(
            null,
            this.compareToggle.checked,
            false
          );
        }

        setTimeout(() => {
          this.classList.add(
            'transition-ready'
          );

          this.productsGrid?.classList.add(
            'transition-ready'
          );
        }, 500);
      } else if (
        theme.settings.compareToggle ===
        'none'
      ) {
        this.toggleCompare(
          null,
          true,
          false
        );
      }

      /*
       * 没有筛选组件时，
       * Sort By 使用普通页面跳转。
       */
      if (
        !this.filtersComponent &&
        this.sortBy
      ) {
        this.sortBy.addEventListener(
          'change',
          ProductsToolbar
            .handleSortByChange
        );
      }
    }

    /**
     * 更新 Compare 状态。
     *
     * @param {Event|null} event
     * @param {boolean|null} checked
     * @param {boolean} persist
     */
    toggleCompare(
      event,
      checked = null,
      persist = true
    ) {
      const isChecked = event
        ? event.target.checked
        : checked;

      if (this.productsGrid) {
        this.productsGrid.dataset.compare =
          String(isChecked);
      }

      const compareButton =
        document.getElementById(
          'compare-drawer-open'
        );

      if (compareButton) {
        compareButton.classList.toggle(
          'is-out',
          !isChecked
        );
      }

      if (
        !event &&
        this.compareToggle
      ) {
        this.compareToggle.checked =
          Boolean(isChecked);
      }

      if (
        persist &&
        !Shopify.designMode
      ) {
        theme.storageUtil.set(
          'compare-toggle',
          isChecked
        );
      }

      /*
       * Compare 开启后按需加载资源。
       */
      if (isChecked) {
        const resourcesTag =
          document.getElementById(
            'compare-resources'
          );

        if (resourcesTag) {
          try {
            const resources =
              JSON.parse(
                resourcesTag.textContent
              );

            resources.forEach(
              (resource) => {
                if (
                  resource.type === 'js'
                ) {
                  const script =
                    document.createElement(
                      'script'
                    );

                  script.src =
                    resource.path;

                  document.head.appendChild(
                    script
                  );
                }

                if (
                  resource.type === 'css'
                ) {
                  const link =
                    document.createElement(
                      'link'
                    );

                  link.href =
                    resource.path;

                  link.type =
                    'text/css';

                  link.rel =
                    'stylesheet';

                  document.head.appendChild(
                    link
                  );
                }
              }
            );

            resourcesTag.remove();
          } catch (error) {
            console.warn(
              '[ProductsToolbar] Invalid compare resources.',
              error
            );
          }
        }
      }
    }

    /**
     * 打开完整筛选抽屉。
     */
    toggleFilters(event) {
      event?.preventDefault();

      if (!this.filtersComponent) {
        console.warn(
          '[ProductsToolbar] facet-filters not found.'
        );

        return;
      }

      /*
       * 恢复所有筛选分组。
       */
      if (
        typeof this.filtersComponent
          .resetFilterGroups ===
        'function'
      ) {
        this.filtersComponent
          .resetFilterGroups();
      }

      /*
       * 打开筛选抽屉。
       */
      this.filtersComponent.open();

      /*
       * 设置完整 Filter 激活状态。
       */
      this.filterToggle?.classList.add(
        'is-active'
      );

      this.filterToggle?.setAttribute(
        'aria-expanded',
        'true'
      );

      /*
       * 清除快捷按钮状态。
       */
      this.quickFilterButtons.forEach(
        (button) => {
          button.classList.remove(
            'is-active'
          );

          button.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      );
    }

    /**
     * 打开 Category、Color、Size 或 Activity。
     */
    openFilterGroup(event) {
      event.preventDefault();

      const button =
        event.currentTarget;

      if (
        !button ||
        !this.filtersComponent
      ) {
        return;
      }

      const paramName =
        button.dataset.filterGroup ||
        '';

      const title =
        button.dataset.filterTitle ||
        button.textContent.trim();

      if (!paramName) {
        console.warn(
          '[ProductsToolbar] Missing data-filter-group.',
          button
        );

        return;
      }

      if (
        typeof this.filtersComponent
          .showFilterGroup !==
        'function'
      ) {
        console.warn(
          '[ProductsToolbar] showFilterGroup() is missing from facet-filters.js.'
        );

        return;
      }

      /*
       * 只显示当前指定筛选组。
       */
      this.filtersComponent
        .showFilterGroup(
          paramName,
          title
        );

      /*
       * 打开筛选抽屉。
       */
      this.filtersComponent.open();

      /*
       * 取消总 Filter 状态。
       */
      this.filterToggle?.classList.remove(
        'is-active'
      );

      this.filterToggle?.setAttribute(
        'aria-expanded',
        'false'
      );

      /*
       * 设置当前快捷按钮状态。
       */
      this.quickFilterButtons.forEach(
        (quickButton) => {
          const isActive =
            quickButton === button;

          quickButton.classList.toggle(
            'is-active',
            isActive
          );

          quickButton.setAttribute(
            'aria-expanded',
            String(isActive)
          );
        }
      );
    }

    /**
     * 清除筛选按钮的视觉状态。
     */
    resetFilterButtonStates() {
      this.filterToggle?.classList.remove(
        'is-active'
      );

      this.filterToggle?.setAttribute(
        'aria-expanded',
        'false'
      );

      this.quickFilterButtons.forEach(
        (button) => {
          button.classList.remove(
            'is-active'
          );

          button.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      );
    }

    /**
     * Grid/List 布局切换。
     *
     * @param {Event|null} event
     * @param {string|null} layout
     */
    handleLayoutChange(
      event,
      layout
    ) {
      if (!this.productsGrid) return;

      const nextLayout =
        layout ||
        event?.target?.value;

      if (!nextLayout) return;

      this.productsGrid.dataset.layout =
        nextLayout;

      if (!layout) {
        theme.storageUtil.set(
          'products-layout',
          nextLayout
        );
      }
    }

    /**
     * 筛选功能关闭时处理 Sort By。
     *
     * @param {CustomEvent} event
     */
    static handleSortByChange(event) {
      const selectedValue =
        event.detail?.selectedValue;

      if (!selectedValue) return;

      const urlObject =
        new URL(
          window.location.href
        );

      urlObject.searchParams.set(
        'sort_by',
        selectedValue
      );

      urlObject.hash =
        'products-toolbar';

      window.location.href =
        urlObject.toString();
    }
  }

  customElements.define(
    'products-toolbar',
    ProductsToolbar
  );
}